export const togglePreventScroll = (activate) => {
  if (typeof activate === 'undefined') {
    activate = false
  }
  $('body, html').toggleClass('prevent-scroll', activate)
}
